import { ComponentProps } from "react";
import { Box, Theme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Modal } from "@rentablo/components";
import { CenteredModalHeader } from "@components";
import { SecuritiesAddAndEditForm } from "@features/securities/components/SecuritiesAddAndEditForm";

type FormProps = ComponentProps<typeof SecuritiesAddAndEditForm>;

interface Props {
  isOpen: boolean;
  onClose: () => void;
  securityMeta: FormProps["securityMeta"];
  watchlists: FormProps["watchlists"];
  currentWatchlist?: FormProps["currentWatchlist"];
  titleKey?: string;
  onSaved: (savedWatchlistId?: number) => void;
}

export const AddToWatchlistModal = ({
  isOpen,
  onClose,
  securityMeta,
  watchlists,
  currentWatchlist,
  titleKey = "watchlistsCreatePage.breadcrumbs.create",
  onSaved,
}: Props) => {
  const { t } = useTranslation();
  const isSM = useMediaQuery((theme: Theme) => theme.breakpoints.down("sm"));

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      width="600px"
      position={isSM ? "bottom" : "centered"}
      height={isSM ? "auto" : "calc(100% - 30px)"}
      maxHeight={isSM ? "unset" : "820px"}
      contentPadding={isSM ? "16px 16px" : undefined}
      zIndex={4001}
      title={<CenteredModalHeader title={t(titleKey)} onClose={onClose} />}
    >
      <Box display="flex" flexDirection="column" flex={1} minHeight={0}>
        <SecuritiesAddAndEditForm
          currentWatchlist={currentWatchlist}
          watchlists={watchlists}
          securityMeta={securityMeta}
          onSave={onSaved}
        />
      </Box>
    </Modal>
  );
};
